module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "id": "project"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-collapse', {
    staticStyle: {
      "margin-bottom": "15px"
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "title": "操作面板",
      "name": "1"
    }
  }, [_c('div', {
    staticClass: "t-op__container"
  }, [_c('div', {
    staticClass: "t-op__item btn__ction"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-circle-plus"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("添加")])], 1), _vm._v(" "), _c('div', {
    staticClass: "t-op__item filter__action"
  }, [_c('div', {
    staticClass: "search-item-progress"
  }, [_c('el-col', {
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "span": 4
    }
  }, [_c('span', {
    staticClass: "progress-label"
  }, [_vm._v("进度：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8,
      "offset": 2
    }
  }, [_c('span', [_vm._v("从")]), _vm._v(" "), _c('el-slider', {
    attrs: {
      "max": 1,
      "min": 0,
      "step": 0.01,
      "format-tooltip": _vm.formatTooltip
    },
    model: {
      value: (_vm.progressStart),
      callback: function($$v) {
        _vm.progressStart = $$v
      },
      expression: "progressStart"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8,
      "offset": 2
    }
  }, [_c('span', [_vm._v("至")]), _vm._v(" "), _c('el-slider', {
    attrs: {
      "max": 1,
      "min": 0,
      "step": 0.01,
      "format-tooltip": _vm.formatTooltip
    },
    model: {
      value: (_vm.progressEnd),
      callback: function($$v) {
        _vm.progressEnd = $$v
      },
      expression: "progressEnd"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search-item-project"
  }, [_c('el-select', {
    staticClass: "item project",
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择项目"
    },
    model: {
      value: (_vm.projectId),
      callback: function($$v) {
        _vm.projectId = $$v
      },
      expression: "projectId"
    }
  }, _vm._l((_vm.projects), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.projectName,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', [_c('el-button', {
    staticClass: "search",
    attrs: {
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.loadData
    }
  })], 1)])])])], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.tableData,
      "width": "100%",
      "height": _vm.tableHeight,
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "type": "index",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "show-overflow-tooltip": "",
      "label": "客户名称",
      "prop": "customerName",
      "min-width": "180",
      "formatter": _vm.fmtCustomerId
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "show-overflow-tooltip": "",
      "label": "项目名称",
      "prop": "projectName",
      "min-width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "签约",
      "prop": "signStatus",
      "min-width": "120",
      "filters": _vm.editItem.signStatusList,
      "filter-method": _vm.filterSignStatus
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "阶段",
      "prop": "stage",
      "min-width": "130",
      "filters": _vm.editItem.stageList,
      "filter-method": _vm.filterStageStatus
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "完成比例",
      "prop": "progressNow",
      "min-width": "150",
      "formatter": _vm.fmtProgress
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "负责人",
      "prop": "leaderName",
      "min-width": "120",
      "formatter": _vm.fmtLeader
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "约定开始时间",
      "prop": "appointCreateTime",
      "min-width": "180",
      "formatter": _vm.fmtJsDate
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "约定结束时间",
      "prop": "appointEndTime",
      "min-width": "180",
      "formatter": _vm.fmtJsDate
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "实际开始时间",
      "prop": "realCreateTime",
      "min-width": "180",
      "formatter": _vm.fmtJsDate
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "实际结束时间",
      "prop": "realEndTime",
      "min-width": "180",
      "formatter": _vm.fmtJsDate
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "标准UT量",
      "prop": "consumption",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "180",
      "label": "预估总成本",
      "prop": "predictCost",
      "formatter": _vm.fmtMoney
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "180",
      "label": "其他成本",
      "prop": "otherCost",
      "formatter": _vm.fmtOtherCost
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "right",
      "label": "操作",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("修改\n                            ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDelete(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除\n                            ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "padding": "10px 0px"
    },
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "hide-on-single-page": _vm.value,
      "page-size": _vm.pageSize,
      "total": _vm.total,
      "current-page": _vm.pageIndex
    },
    on: {
      "current-change": _vm.onCurrentChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.editItem.title,
      "width": _vm.editItem.width,
      "visible": _vm.editItem.visible
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.editItem, "visible", $event)
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.editItem.data
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户名称",
      "label-width": "150px"
    }
  }, [_c('el-select', {
    staticClass: "input-with-select",
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.editItem.data.customerId),
      callback: function($$v) {
        _vm.$set(_vm.editItem.data, "customerId", $$v)
      },
      expression: "editItem.data.customerId"
    }
  }, _vm._l((_vm.editItem.customerList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.customer,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "项目名称",
      "label-width": "150px"
    }
  }, [_c('el-input', {
    attrs: {
      "autocomplete": "off",
      "clearable": ""
    },
    model: {
      value: (_vm.editItem.data.projectName),
      callback: function($$v) {
        _vm.$set(_vm.editItem.data, "projectName", $$v)
      },
      expression: "editItem.data.projectName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否签约",
      "label-width": "150px"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.editItem.data.signStatus),
      callback: function($$v) {
        _vm.$set(_vm.editItem.data, "signStatus", $$v)
      },
      expression: "editItem.data.signStatus"
    }
  }, _vm._l((_vm.editItem.signStatusList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "阶段",
      "label-width": "150px"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.editItem.data.stage),
      callback: function($$v) {
        _vm.$set(_vm.editItem.data, "stage", $$v)
      },
      expression: "editItem.data.stage"
    }
  }, _vm._l((_vm.editItem.stageList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "约定开始-结束时间",
      "label-width": "150px"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "width": "200px",
      "type": "daterange",
      "start-placeholder": "开始时间",
      "end-placeholder": "结束时间",
      "default-time": ['00:00:00', '23:59:59']
    },
    on: {
      "change": _vm.appointDateRangeChange
    },
    model: {
      value: (_vm.appointDateRange),
      callback: function($$v) {
        _vm.appointDateRange = $$v
      },
      expression: "appointDateRange"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "完成比例",
      "label-width": "150px"
    }
  }, [_c('el-slider', {
    attrs: {
      "max": 1,
      "min": 0,
      "format-tooltip": _vm.formatTooltip,
      "disabled": ""
    },
    model: {
      value: (_vm.editItem.data.progressNow),
      callback: function($$v) {
        _vm.$set(_vm.editItem.data, "progressNow", $$v)
      },
      expression: "editItem.data.progressNow"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "项目负责人",
      "label-width": "150px"
    }
  }, [_c('el-select', {
    staticClass: "input-with-select",
    attrs: {
      "filterable": _vm.editItem.filter,
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.editItem.data.leaderId),
      callback: function($$v) {
        _vm.$set(_vm.editItem.data, "leaderId", $$v)
      },
      expression: "editItem.data.leaderId"
    }
  }, _vm._l((_vm.editItem.userList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "参与人员",
      "label-width": "150px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "fit": "",
      "data": _vm.editItem.joinUsers,
      "border": "",
      "show-summary": "",
      "summary-method": _vm.getSummaries
    }
  }, [_c('el-table-column', {
    attrs: {
      "width": "80px",
      "type": "index",
      "label": "序号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150px",
      "prop": "userName",
      "label": "员工姓名"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          attrs: {
            "filterable": _vm.editItem.filter,
            "placeholder": "请选择"
          },
          on: {
            "change": _vm.handleChange
          },
          model: {
            value: (scope.row.userId),
            callback: function($$v) {
              _vm.$set(scope.row, "userId", $$v)
            },
            expression: "scope.row.userId"
          }
        }, _vm._l((_vm.joinUserOptions), function(group) {
          return _c('el-option-group', {
            key: group.label,
            attrs: {
              "label": group.label
            }
          }, _vm._l((group.options), function(item) {
            return _c('el-option', {
              key: item.id,
              attrs: {
                "label": item.name,
                "value": item.id
              }
            })
          }), 1)
        }), 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "initWork",
      "label": "分配工作量(天)"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input-number', {
          attrs: {
            "step": 1,
            "min": 0
          },
          on: {
            "change": _vm.handleChange
          },
          model: {
            value: (scope.row.initWork),
            callback: function($$v) {
              _vm.$set(scope.row, "initWork", $$v)
            },
            expression: "scope.row.initWork"
          }
        }), _vm._v(" "), (scope.row.initWork === 0) ? _c('el-checkbox', {
          staticClass: "el-input-number",
          model: {
            value: (scope.row.noDateLimit),
            callback: function($$v) {
              _vm.$set(scope.row, "noDateLimit", $$v)
            },
            expression: "scope.row.noDateLimit"
          }
        }, [_vm._v("\n                                            无日期限制\n                                        ")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150px",
      "prop": "cost",
      "label": "合算薪酬(元)"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.cost))]), _vm._v(" "), _c('i', {
          staticClass: "el-icon-delete",
          staticStyle: {
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              return _vm.handleJoinDataDel(scope.row.index)
            }
          }
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary",
      "icon": "el-icon-circle-plus"
    },
    on: {
      "click": _vm.handleJoinData
    }
  }, [_vm._v("添加参与人员\n                            ")])], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "其它成本",
      "label-width": "150px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "fit": "",
      "data": _vm.editItem.otherCost,
      "border": "",
      "show-summary": "",
      "summary-method": _vm.getOtherCostSummaries
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "序号",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "itemName",
      "label": "成本项描述"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "type": "textarea",
            "autocomplete": "off"
          },
          model: {
            value: (scope.row.itemName),
            callback: function($$v) {
              _vm.$set(scope.row, "itemName", $$v)
            },
            expression: "scope.row.itemName"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cost",
      "label": "花费金额(元)"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          staticClass: "w-100",
          attrs: {
            "type": "number",
            "autocomplete": "off"
          },
          on: {
            "change": _vm.handleChange
          },
          model: {
            value: (scope.row.cost),
            callback: function($$v) {
              _vm.$set(scope.row, "cost", $$v)
            },
            expression: "scope.row.cost"
          }
        }), _vm._v(" "), _c('i', {
          staticClass: "el-icon-delete",
          staticStyle: {
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              return _vm.handleOtherCostDel(scope.row.index)
            }
          }
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary",
      "icon": "el-icon-circle-plus"
    },
    on: {
      "click": _vm.handleOtherCost
    }
  }, [_vm._v("添加其它成本\n                            ")])], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "标准UT量",
      "label-width": "150px"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.editItem.data.consumption),
      callback: function($$v) {
        _vm.$set(_vm.editItem.data, "consumption", $$v)
      },
      expression: "editItem.data.consumption"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("人天")])], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "预估成本",
      "label-width": "150px"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.editItem.data.predictCost),
      callback: function($$v) {
        _vm.$set(_vm.editItem.data, "predictCost", $$v)
      },
      expression: "editItem.data.predictCost"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("元")])], 2)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editItem.visible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46f27910"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/admin/project/projectManage.vue
// module id = 611
// module chunks = 1